import { Component, Vue } from 'vue-property-decorator';

import ContradictoryCheckListComponent from './ContradictoryCheckListComponent/ContradictoryCheckListComponent.vue';
import QualityControlsList from './QualityControlsList/QualityControlsList.vue';

@Component({
  components: {
    QualityControlsList,
    ContradictoryCheckListComponent,
  },
})
export default class Reports extends Vue {
  hasNoControls = false;
  view = 'controls';

  get showControls() {
    return this.view === 'controls';
  }

  noControlsFound() {
    this.hasNoControls = true;
    this.view = 'requests';
  }
}
